import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EVENT_FEATURE } from '../actions/event.actions';
import { EventState } from '../reducers/event.reducer';

const featureSelector = createFeatureSelector<EventState>(EVENT_FEATURE);

export const selectSearchedEvent = createSelector(
  featureSelector,
  (state) => state.searchedEvent
);

export const selectFilteredState = createSelector(
  featureSelector,
  (state) => state.filteredState
);

export const selectFilteredEvents = createSelector(
  featureSelector,
  (state) => state.filteredEvents
);
